<template>
    <div>
        <div class="table-responsive mb-0" v-if="type == 0">
            <table class="table table-bordered table-sm ">
                <thead>
                    <tr>
                        <th></th>
                        <th colspan="2" class="text-nowrap">Başlangıç</th>
                        <th colspan="2" class="text-nowrap">Bitiş</th>
                        <th colspan="2" class="text-nowrap">Aylak Rota</th>
                        <th colspan="20"></th>
                    </tr>
                    <tr>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Referans Model">Ref. Mod.</th>
                        <th class="text-nowrap">İl</th>
                        <th class="text-nowrap">İlçe</th>
                        <th class="text-nowrap">İl</th>
                        <th class="text-nowrap">İlçe</th>
                        <th class="text-nowrap">İl</th>
                        <th class="text-nowrap">İlçe</th>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Referans Model Araç Kapasitesi">RMAK (TON)</th>
                        <th class="text-nowrap">Mesafe (KM)</th>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Çalışma Gün Sayısı">ÇGS</th>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Sefer Sayısı">SS</th>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Sabit Maliyet">SM (TL/Gün)</th>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Birim Değişken Maliyet">BDM (TL/TON-KM)</th>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Başabaş Noktası">BBN (TL/TON)</th>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Referans Model Kâr Oranı">RMKO (%)</th>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Kar Oranı İle Satış Fiyatı">KOSF (TL/TON)</th>
                        <th class="text-nowrap">KAR (TL/TON)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(route,index) in routes" :key="[type,index].join()">
                        <td class="text-nowrap">{{route.VehicleReferenceModelName}}</td>
                        <td class="text-nowrap">{{route.StartProvinceName}}</td>
                        <td class="text-nowrap">{{route.StartDistrictName}}</td>
                        <td class="text-nowrap">{{route.EndProvinceName}}</td>
                        <td class="text-nowrap">{{route.EndDistrictName}}</td>
                        <td class="text-nowrap">{{route.IdleProvinceName || "-"}}</td>
                        <td class="text-nowrap">{{route.IdleDistrictName || "-"}}</td>
                        <td class="text-nowrap">{{route.VehicleReferenceModelCapacity || "-"}}</td>
                        <td class="text-nowrap">{{route.IdleRouteKm ? route.IdleRouteKm : route.CalculatedKm}}</td>
                        <td class="text-nowrap">{{route.CountOfDaysWorked}}</td>
                        <td class="text-nowrap">{{route.CountOfTrips}}</td>
                        <td class="text-nowrap">{{$safe(route.IntegrationKmWithIdleRouteResult,'FixedCostStr') ? $safe(route.IntegrationKmWithIdleRouteResult,'FixedCostStr') : $safe(route.IntegrationKmResult,'FixedCostStr')}}</td>
                        <td class="text-nowrap">{{$safe(route.IntegrationKmWithIdleRouteResult,'TotalTireUnitCostStr') ? route.IntegrationKmWithIdleRouteResult.TotalTireUnitCostStr : route.IntegrationKmResult.TotalTireUnitCostStr}}</td>
                        <td class="text-nowrap">{{$safe(route.IntegrationKmWithIdleRouteResult,'BreakevenPointTonStr') ? route.IntegrationKmWithIdleRouteResult.BreakevenPointTonStr : route.IntegrationKmResult.BreakevenPointTonStr}}</td>
                        <td class="text-nowrap">{{route.ProfitRate}}</td>
                        <td class="text-nowrap">{{$safe(route.IntegrationKmWithIdleRouteResult,'SalesPriceWithProfitRateTonStr') ? route.IntegrationKmWithIdleRouteResult.SalesPriceWithProfitRateTonStr : route.IntegrationKmResult.SalesPriceWithProfitRateTonStr}}</td>
                        <td class="text-nowrap">{{$safe(route.IntegrationKmWithIdleRouteResult,'AmountOfProfitStr') ? route.IntegrationKmWithIdleRouteResult.AmountOfProfitStr : route.IntegrationKmResult.AmountOfProfitStr}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="table-responsive mb-0" v-if="type == 1">
            <table class="table table-bordered table-sm">
                <thead>
                    <tr>
                        <th></th>
                        <th colspan="2" class="text-nowrap">Başlangıç</th>
                        <th colspan="2" class="text-nowrap">Bitiş</th>
                        <th colspan="2" class="text-nowrap">Aylak Rota</th>
                        <th colspan="20"></th>
                    </tr>
                    <tr>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Referans Model">Ref. Mod.</th>
                        <th class="text-nowrap">İl</th>
                        <th class="text-nowrap">İlçe</th>
                        <th class="text-nowrap">İl</th>
                        <th class="text-nowrap">İlçe</th>
                        <th class="text-nowrap">İl</th>
                        <th class="text-nowrap">İlçe</th>
                        <th v-b-tooltip.noninteractive.hover.bottom title="Referans Model Araç Kapasitesi">RMAK (TON)</th>
                        <th>Mesafe (KM)</th>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Çalışma Gün Sayısı">ÇGS</th>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Sefer Sayısı">SS</th>
                        <th v-b-tooltip.noninteractive.hover.bottom title="Sabit Maliyet">SM (TL/Gün)</th>
                        <th v-b-tooltip.noninteractive.hover.bottom title="Birim Değişken Maliyet">BDM (TL/TON-KM)</th>
                        <th v-b-tooltip.noninteractive.hover.bottom title="Başabaş Noktası">BBN (TL/KM)</th>
                        <th v-b-tooltip.noninteractive.hover.bottom title="Referans Model Kâr Oranı">RMKO (%)</th>
                        <th v-b-tooltip.noninteractive.hover.bottom title="Kar Oranı İle Satış Fiyatı">KOSF (TL/KM)</th>
                        <th>KAR (TL/KM)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(route,index) in routes" :key="[type,index].join()">
                        <td class="text-nowrap">{{route.VehicleReferenceModelName}}</td>
                        <td class="text-nowrap">{{route.StartProvinceName}}</td>
                        <td class="text-nowrap">{{route.StartDistrictName}}</td>
                        <td class="text-nowrap">{{route.EndProvinceName}}</td>
                        <td class="text-nowrap">{{route.EndDistrictName}}</td>
                        <td class="text-nowrap">{{route.IdleProvinceName || "-"}}</td>
                        <td class="text-nowrap">{{route.IdleDistrictName || "-"}}</td>
                        <td class="text-nowrap">{{route.VehicleReferenceModelCapacity || "-"}}</td>
                        <td class="text-nowrap">{{route.IdleRouteKm ? route.IdleRouteKm : route.CalculatedKm}}</td>
                        <td class="text-nowrap">{{route.CountOfDaysWorked}}</td>
                        <td class="text-nowrap">{{route.CountOfTrips}}</td>
                        <td class="text-nowrap">{{$safe(route.IntegrationKmWithIdleRouteResult,'FixedCostStr') ? $safe(route.IntegrationKmWithIdleRouteResult,'FixedCostStr') : $safe(route.IntegrationKmResult,'FixedCostStr')}}</td>
                        <td class="text-nowrap">{{$safe(route.IntegrationKmWithIdleRouteResult,'TotalTireUnitCostStr') ? route.IntegrationKmWithIdleRouteResult.TotalTireUnitCostStr : route.IntegrationKmResult.TotalTireUnitCostStr}}</td>
                        <td class="text-nowrap">{{$safe(route.IntegrationKmWithIdleRouteResult,'BreakevenPointKmStr') ? route.IntegrationKmWithIdleRouteResult.BreakevenPointKmStr : route.IntegrationKmResult.BreakevenPointKmStr}}</td>
                        <td class="text-nowrap">{{route.ProfitRate}}</td>
                        <td class="text-nowrap">{{$safe(route.IntegrationKmWithIdleRouteResult,'SalesPriceWithProfitRateKmStr') ? route.IntegrationKmWithIdleRouteResult.SalesPriceWithProfitRateKmStr : route.IntegrationKmResult.SalesPriceWithProfitRateKmStr}}</td>
                        <td class="text-nowrap">{{$safe(route.IntegrationKmWithIdleRouteResult,'AmountOfProfitStr') ? route.IntegrationKmWithIdleRouteResult.AmountOfProfitStr : route.IntegrationKmResult.AmountOfProfitStr}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="table-responsive mb-0" v-if="type == 2">
            <table class="table table-bordered table-sm">
                <thead>
                    <tr>
                        <th></th>
                        <th colspan="2" class="text-nowrap">Başlangıç</th>
                        <th colspan="2" class="text-nowrap">Bitiş</th>
                        <th colspan="2" class="text-nowrap">Aylak Rota</th>
                        <th colspan="20"></th>
                    </tr>
                    <tr>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Referans Model">Ref. Mod.</th>
                        <th class="text-nowrap">İl</th>
                        <th class="text-nowrap">İlçe</th>
                        <th class="text-nowrap">İl</th>
                        <th class="text-nowrap">İlçe</th>
                        <th class="text-nowrap">İl</th>
                        <th class="text-nowrap">İlçe</th>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Referans Model Araç Kapasitesi">RMAK (TON)</th>
                        <th class="text-nowrap">Mesafe (KM)</th>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Çalışma Gün Sayısı">ÇGS</th>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Sefer Sayısı">SS</th>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Sabit Maliyet">SM (TL/Gün)</th>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Birim Değişken Maliyet">BDM (TL/TON-KM)</th>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Başabaş Noktası">BBN (TL/Rota)</th>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Referans Model Kâr Oranı">RMKO (%)</th>
                        <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Kar Oranı İle Satış Fiyatı">KOSF (TL/Rota)</th>
                        <th class="text-nowrap">KAR (TL/Rota)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(route,index) in routes" :key="[type,index].join()">
                        <td class="text-nowrap">{{route.VehicleReferenceModelName}}</td>
                        <td class="text-nowrap">{{route.StartProvinceName}}</td>
                        <td class="text-nowrap">{{route.StartDistrictName}}</td>
                        <td class="text-nowrap">{{route.EndProvinceName}}</td>
                        <td class="text-nowrap">{{route.EndDistrictName}}</td>
                        <td class="text-nowrap">{{route.IdleProvinceName || "-"}}</td>
                        <td class="text-nowrap">{{route.IdleDistrictName || "-"}}</td>
                        <td class="text-nowrap">{{route.VehicleReferenceModelCapacity || "-"}}</td>
                        <td class="text-nowrap">{{route.IdleRouteKm ? route.IdleRouteKm : route.CalculatedKm}}</td>
                        <td class="text-nowrap">{{route.CountOfDaysWorked}}</td>
                        <td class="text-nowrap">{{route.CountOfTrips}}</td>
                        <td class="text-nowrap">{{$safe(route.IntegrationKmWithIdleRouteResult,'FixedCostStr') ? $safe(route.IntegrationKmWithIdleRouteResult,'FixedCostStr') : $safe(route.IntegrationKmResult,'FixedCostStr')}}</td>
                        <td class="text-nowrap">{{$safe(route.IntegrationKmWithIdleRouteResult,'TotalTireUnitCostStr') ? route.IntegrationKmWithIdleRouteResult.TotalTireUnitCostStr : route.IntegrationKmResult.TotalTireUnitCostStr}}</td>
                        <td class="text-nowrap">{{$safe(route.IntegrationKmWithIdleRouteResult,'TotalCostStr') ? route.IntegrationKmWithIdleRouteResult.TotalCostStr : route.IntegrationKmResult.TotalCostStr}}</td>
                        <td class="text-nowrap">{{route.ProfitRate}}</td>
                        <td class="text-nowrap">{{$safe(route.IntegrationKmWithIdleRouteResult,'LastTotalRevenueWithProfitRateStr') ? route.IntegrationKmWithIdleRouteResult.LastTotalRevenueWithProfitRateStr : route.IntegrationKmResult.LastTotalRevenueWithProfitRateStr}}</td>
                        <td class="text-nowrap">{{$safe(route.IntegrationKmWithIdleRouteResult,'AmountOfProfitStr') ? route.IntegrationKmWithIdleRouteResult.AmountOfProfitStr : route.IntegrationKmResult.AmountOfProfitStr}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue'
export default {
    directives:{
        "b-tooltip":VBTooltip
    },
    props:{
        type:Number,
        routes:Array
    }
}
</script>

<style>

</style>